import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from "../../constant/api";
import CartTopProduct from '../../components/CartTopselling/CartTopProduct';
import CartCard from '../../components/CartCard/CartCard';
import { IoMdSearch } from "react-icons/io";
import SearchInput from '../../components/Home/SearchInput/SearchInput';


const Cart = () => {

  const [loading, setLoading] = useState(true);
  const [topProducts, setTopProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");


  // Function to get the category name based on category_id
  const getCategoryName = (id) => {
    const category = categories.find((cat) => cat.id === id);
    return category ? category.name : 'Unknown Category';
  };

  useEffect(() => {
    // Fetch top selling products and categories from the API
    const fetchTopSellingProducts = async () => {
      

      setLoading(true);
      try {
        const [topProductsResponse, categoriesResponse] = await Promise.all([
          axios.get(`${BASE_URL}/products/trending/`),
          axios.get(`${BASE_URL}/categories/`),
        ]);

        setTopProducts(topProductsResponse.data.Data || []); // Set top-selling products
        setCategories(categoriesResponse.data.Data || []); // Set categories
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchTopSellingProducts();
  }, []); console.log(topProducts);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };



  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner-border animate-spin border-4 rounded-full w-16 h-16 border-blue-500 border-t-transparent"></div>
        <p className="ml-4">Loading cart...</p>
      </div>
    );
  }

  return (
    <div className="border-t-2 container mx-auto">
       
      <div className="p-4 mb-28  mt-5">
      <SearchInput
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search items..."
          head="Cart"
        />
       

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row w-full mt-10 space-y-6 lg:space-y-0">
          {/* Left Sidebar - Top Selling Products */}
          <div className="hidden lg:block w-1/5">
            <CartTopProduct products={topProducts} getCategoryName={getCategoryName} />
          </div>

          {/* Cart Items Section */}
          <div className="w-full lg:w-4/5">
          <CartCard searchQuery={searchQuery} />
          </div>
        </div>
      </div>
    </div>


  );
};

export default Cart;



